import { contentStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsContent";
import { css } from "styled-components";

contentStyles.container = {
    ...contentStyles.container,
    css: css`
        div {
            font-size: 16px;
        }
    `,
};
